<template>
    <v-card
            class="mx-auto my-4 pa-2"
            max-width="90%"
    >
        <v-card-title>
            <v-row>
                <v-col
                        style="line-height: 1.5em"
                        cols="12"
                        md="8"
                >
                    {{ experiment.title }} <span class="caption">({{ experiment.uuid }})</span><br>
                    <v-btn
                            fab
                            x-small
                            dark
                            class="mr-2"
                            color="grey darken-1"
                            @click.stop.prevent="copyMixpanelParameter"
                    >
                        <v-icon dark>mdi-content-copy</v-icon>
                    </v-btn>
                    <span class="text--disabled subtitle-1 font-weight-light">{{ getMixpanelParameter }}</span>
                    <input type="hidden" :id="'copy-helper-mixpanel-parameter-' + experiment.uuid" :value="getMixpanelParameter">
                </v-col>
                <v-col
                        class="text-right"
                        cols="12"
                        md="4"
                >
                    <v-btn
                            absolute right
                            raised
                            small
                            dark
                            color="grey darken-3"
                            target="_blank"
                            :href="getMixpanelLink"
                    >
                        Mixpanel
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>



        <v-card-text>
            <v-container class="small-chart">
                <v-row>
                    <v-col
                            cols="12"
                            md="3"
                    >
                        Participants: {{ formatNumber(experiment.participants_data.count) }}
                        <v-list dense>
                            <v-list-item
                                    v-for="(variant, index) in experiment.variants"
                                    v-bind:key="variant.uuid"
                                    v-bind:index="index"
                                    v-bind:variant="variant"
                            >
                                <v-list-item-content>
                                    <v-chip
                                            small
                                            :color="colors[index]"
                                            text-color="white"
                                    >
                                        {{ variant.value }}
                                    </v-chip>
                                    {{ formatNumber(variant.participants_data.count) }}
                                    ({{ getPercentForVariant(index) }}%)
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col
                            cols="12"
                            md="9"
                    >
                        <LineChart
                                :styles="lineChartStyles"
                                :chart-data="getChartData"
                                :options="chartOptions"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>

        </v-card-actions>
    </v-card>
</template>

<script>
    import LineChart from '@/components/LineChart';

    export default {
        name: 'Experiment',
        props: {
            responseData: Object,
        },
        data() {
            return {
                experiment: this.responseData.data,
                links: this.responseData.links,
                chartOptions: {
                    maintainAspectRatio: false,
                    responsive: true,
                    tooltips: {
                        mode: 'index',
                        intersect: false,
                    },
                    hover: {
                        mode: 'nearest',
                        intersect: true,
                    },
                    legend: {
                        display: false,
                    }
                },
                colors: [
                    'rgb(255, 99, 132)',
                    'rgb(0,106,140)',
                    'rgb(115,145,113)',
                    'rgb(228, 191, 13)',
                    'rgb(148,121,191)',
                    'rgb(226, 89, 24)'
                ]
            }
        },
        components: {
            LineChart,
        },
        computed: {
            lineChartStyles() {
                return {
                    height: '200px',
                }
            },
            getMixpanelParameter() {
                return 'ab_exp_' + this.experiment.title
                    .replace(/[^a-z_0-9\- ]/gi, '')
                    .trim()
                    .replace(/ /g, '-')
                    .toLowerCase()
            },
            getMixpanelLink() {
                return 'https://mixpanel.com/report/lexicon/#transformations/event-properties/' + this.getMixpanelParameter
            },
            getChartData() {

                let labels = []
                let datasets = []


                if (
                    this.experiment.variants.length &&
                    typeof this.experiment.variants[0].participants_data !== 'undefined' &&
                    typeof this.experiment.variants[0].participants_data.recent != 'undefined' &&
                    this.experiment.variants[0].participants_data.recent.length
                ) {

                    for (let i = 0; i < this.experiment.variants.length; i++) {

                        const variant = this.experiment.variants[i]

                        let dataset = {
                            label: variant.value,
                            fill: false,
                            data: variant.participants_data.recent,
                            borderWidth: 0.5,
                            borderColor: this.colors[i],
                            backgroundColor: this.colors[i],
                        }

                        datasets.push(dataset)
                    }

                    for (let i = 1; i <= this.experiment.variants[0].participants_data.recent.length; i++) {
                        let da, mo

                        const date = new Date()
                        const daysDiff = this.experiment.variants[0].participants_data.recent.length - i
                        date.setDate(date.getDate() - daysDiff);

                        da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(date)
                        mo = new Intl.DateTimeFormat('en', {month: 'short'}).format(date)

                        labels.push(`${da}-${mo}`)
                    }
                }

                return {
                    labels: labels,
                    datasets: datasets
                }
            },
        },
        methods: {
            getPercentForVariant(index) {

                if (this.experiment.participants_data.count === 0) {
                    return 0;
                }

                return Math.round(100 * this.experiment.variants[index].participants_data.count / this.experiment.participants_data.count)
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            copyMixpanelParameter() {

                let textToCopy = document.querySelector('#copy-helper-mixpanel-parameter-' + this.experiment.uuid)

                textToCopy.setAttribute('type', 'text')
                textToCopy.select()

                try {
                    const successful = document.execCommand('copy');
                    const msg = successful ? 'successful' : 'unsuccessful';
                    if (msg === 'unsuccessful') {
                        alert('Unable to copy parameter.');
                    }
                } catch (err) {
                    alert('Oops, an error has occurred.');
                }

                textToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
    @import '~vuetify/src/styles/styles.sass'

    @media #{map-get($display-breakpoints, 'sm-and-down')}
        .v-list-item
            display: inline-block
            margin: 0 $form-grid-gutter

    .v-list-item
        padding: 0

</style>
